import React, { ReactChildren } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link as MaterialUILink } from '@material-ui/core';

// @ts-ignore
export const MyPATRouterLink = ({ classes = {}, displayProp = 'flex', ...props }) => <RouterLink style={{ display: displayProp, textDecoration: 'unset', alignItems: 'center', color: '#1d7dea' }} {...props} />;

// @ts-ignore
export default ({ children, ...props }) => <MaterialUILink {...props} component={MyPATRouterLink}>{children}</MaterialUILink>;
